import io from 'socket.io-client';

const endpoint = process.env.REACT_APP_API_URL;

const socket = io(endpoint || 'https://api.comercial.diagonal.social', {
  withCredentials: true,
  transports: ['websocket', 'polling'],
  query: {
    'x-access-token': localStorage.getItem('token') || '',
  },
  autoConnect: true,
  reconnection: true,
  reconnectionAttempts: 5,
});

socket.on('connect', () => {
  console.log('✅ Socket conectado');
});

socket.on('connect_error', (error) => {
  console.error('❌ Socket erro:', error.message);
});

export default socket;
